export default "/images/40bbdde414cbf8274e78fd8edc3e6db7.png";